import ApiService from './../api/ApiService';
import Urls from './../api/Urls';
import Config from '../constants/Config';
import Outlet from '../models/Outlet';
import Menu from '../models/Menu';
import Item from '../models/Item';
import FnbProduct from '../models/FnbProduct';
import TourProperty from '../models/TourProperty';

export function getOutlets(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_OUTLET_LIST,
        params: params,
        parser: data => {
            const rawData = data?.data;
            const itemsRaw = rawData?.result || rawData?.items || rawData || [];
            return {
                items: (itemsRaw || []).map(item => new Outlet(item)),
                pagination: {
                    pageIndex: rawData?.pageIndex,
                    pageSize: rawData?.pageSize,
                    totalCount: rawData?.totalCount,
                }
            };
        }
    }).get();
}

export function getProperties(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_PROPERTY_LIST_ALL,
        params,
        parser: data => (data.data || []).map(item => new TourProperty(item)),
    }).get();
}

const parseLookupData = data => {
    const rawData = data?.data || [];
    return rawData?.result || rawData?.items || rawData || [];
};

export function getFrontendProperties(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_FRONTEND_PROPERTIES,
        params,
        parser: parseLookupData,
    }).get();
}

export function getFrontendOutlets(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_FRONTEND_OUTLETS,
        params,
        parser: parseLookupData,
    }).get();
}

export function getFrontendMenus(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_FRONTEND_MENUS,
        params,
        parser: parseLookupData,
    }).get();
}

export function getFrontendMenuItems(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_FRONTEND_MENU_ITEMS,
        params,
        parser: parseLookupData,
    }).get();
}

export function syncOutlets(payload = { isFullSync: true }) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_OUTLET_SYNC,
    }).post(payload);
}

export function updateOutlet(payload) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_OUTLET_UPDATE,
    }).put(payload);
}

export function getMenus(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_MENU_LIST,
        params,
        parser: data => ({
            items: (data.data?.result || []).map(item => new Menu(item)),
            pagination: {
                pageIndex: data.data?.pageIndex,
                pageSize: data.data?.pageSize,
                totalCount: data.data?.totalCount,
            },
        })
    }).get();
}

export function syncMenus(payload) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_MENU_SYNC,
    }).post(payload);
}

export function syncMenuItems(payload) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_MENU_ITEM_SYNC,
    }).post(payload);
}

export function getMenuItems(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_MENU_ITEM_LIST,
        params,
        parser: data => ({
            items: data.data?.result || [],
            pagination: {
                pageIndex: data.data?.pageIndex,
                pageSize: data.data?.pageSize,
                totalCount: data.data?.totalCount,
            },
        }),
    }).get();
}

export function updateMenuItem(payload) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_MENU_ITEM_UPDATE,
    }).put(payload);
}

export function getMenuDetail(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_MENU_DETAIL,
        endpointParams: { id },
        parser: data => data.data || data
    }).get();
}

export function updateMenu(payload) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_MENU_UPDATE,
    }).put(payload);
}

export function createMenuTranslate(payload) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_MENU_TRANSLATE,
    }).post(payload);
}

export function updateMenuTranslate(payload) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_MENU_TRANSLATE,
    }).put(payload);
}

export function deleteMenuTranslate(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_MENU_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}

export function getItemDetail(id) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.FNB_ITEM_DETAIL,
        endpointParams: { id },
        parser: data => new Item(data.data)
    }).get();
}

export function syncItem(id) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.FNB_ITEM_SYNC,
        endpointParams: { id }
    }).post();
}

export function getCondiments(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_PRODUCT_CONDIMENT_LIST,
        params,
        parser: data => ({
            items: data.data?.result || [],
            pagination: {
                pageIndex: data.data?.pageIndex,
                pageSize: data.data?.pageSize,
                totalCount: data.data?.totalCount,
            },
        }),
    }).get();
}

export function syncCondiments(payload) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_PRODUCT_CONDIMENT_SYNC,
    }).post(payload);
}

export function getCondimentDetail(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_PRODUCT_CONDIMENT_DETAIL,
        endpointParams: { id },
        parser: data => data.data || data
    }).get();
}

export function updateCondiment(payload) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_PRODUCT_CONDIMENT_UPDATE,
    }).put(payload);
}

export function createCondimentTranslate(payload) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_PRODUCT_CONDIMENT_TRANSLATE,
    }).post(payload);
}

export function updateCondimentTranslate(payload) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_PRODUCT_CONDIMENT_TRANSLATE,
    }).put(payload);
}

export function deleteCondimentTranslate(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_PRODUCT_CONDIMENT_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}

export function getOptions(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_PRODUCT_OPTION_LIST,
        params,
        parser: data => ({
            items: data.data?.result || [],
            pagination: {
                pageIndex: data.data?.pageIndex,
                pageSize: data.data?.pageSize,
                totalCount: data.data?.totalCount,
            },
        }),
    }).get();
}

export function syncOptions(payload) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_PRODUCT_OPTION_SYNC,
    }).post(payload);
}

export function getOptionDetail(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_PRODUCT_OPTION_DETAIL,
        endpointParams: { id },
        parser: data => data.data || data
    }).get();
}

export function updateOption(payload) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_PRODUCT_OPTION_UPDATE,
    }).put(payload);
}

// Product Services
export function getProducts(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_PRODUCT_LIST,
        params: params,
        parser: data => ({
            data: (data.data?.result || []).map(item => new FnbProduct(item)),
            pagination: {
                pageIndex: data.data?.pageIndex,
                pageSize: data.data?.pageSize,
                totalCount: data.data?.totalCount,
            }
        })
    }).get();
}

export function syncProducts(payload) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_PRODUCT_SYNC,
    }).post(payload);
}

export function getProductDetail(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_PRODUCT_DETAIL,
        endpointParams: { id },
        parser: data => new FnbProduct(data.data)
    }).get();
}

export function updateProduct(payload) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_PRODUCT_UPDATE,
        // endpointParams: { id: payload.id },
    }).put(payload);
}

export function createProductTranslate(product) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_PRODUCT_TRANSLATE,
    }).post({
        fnbProductId: product.id,
        name: product.name,
        shortName: product.shortName,
        description: product.description,
        languageCode: product.languageCode,
    });
}

export function updateProductTranslate(product) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_PRODUCT_TRANSLATE,
    }).put({
        id: product.id,
        name: product.name,
        shortName: product.shortName,
        description: product.description,
        languageCode: product.languageCode,
    });
}

export function deleteProductTranslate(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_PRODUCT_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}

export function createOptionTranslate(payload) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_PRODUCT_OPTION_TRANSLATE,
    }).post(payload);
}

export function updateOptionTranslate(payload) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_PRODUCT_OPTION_TRANSLATE,
    }).put(payload);
}

export function deleteOptionTranslate(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.FNB_PRODUCT_OPTION_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}
